import { QUESTIONNAIRE_PAGE_BOX_SX } from '../../../common';

export const SUBMIT_PAGE_BOX_SX = {
  height: '500px',
  justifyContent: 'center',
  alignItems: 'center',
  ...QUESTIONNAIRE_PAGE_BOX_SX,
};
